import React, { useState, useEffect } from 'react';
import { fetchCourses, exportCoursesExcel } from '../services/academicFinanceApi';
import { FinanceTable } from './FinanceTable';
import Notifier from '../../../Utils/notify';
import exporticon from '../../../assets/icons/export-data.svg';

export const CoursesList = ({ onCourseClick, onUpdateGrandTotals }) => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [exporting, setExporting] = useState(false);
  const pageSize = 10;

  useEffect(() => {
    loadCourses(currentPage);
  }, [currentPage]);

  const loadCourses = async (page) => {
    try {
      setLoading(true);
      const data = await fetchCourses(page, pageSize);
      setCourses(data.results || []);
      
      // Update grand totals
      if (data.grand_totals) {
        onUpdateGrandTotals(data.grand_totals);
      }
      
      // Calculate total pages
      if (data.count) {
        setTotalPages(Math.ceil(data.count / pageSize));
      }
    } catch (error) {
      console.error('Error loading courses:', error);
      Notifier.error('Failed to load courses');
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      setExporting(true);
      await exportCoursesExcel();
      Notifier.success('Courses data exported successfully');
    } catch (error) {
      console.error('Error exporting courses:', error);
      Notifier.error('Failed to export courses data');
    } finally {
      setExporting(false);
    }
  };

  const handleRowClick = (course) => {
    onCourseClick('specializations', course.id, course.name);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const columns = [
    { header: 'ID', accessor: 'id', width: '80px' },
    { header: 'Course Name', accessor: 'name', width: '200px' },
    { header: 'Alias', accessor: 'alias', width: '150px' },
    { 
      header: 'Total Students', 
      accessor: 'total_students', 
      width: '120px',
      align: 'center'
    },
    { 
      header: 'Imposed Fees', 
      accessor: 'total_imposed_fees', 
      width: '150px',
      align: 'right',
      format: 'currency'
    },
    { 
      header: 'Scheduled Fees', 
      accessor: 'total_scheduled_fee', 
      width: '150px',
      align: 'right',
      format: 'currency'
    },
    { 
      header: 'Paid Fees', 
      accessor: 'total_paid_fees', 
      width: '150px',
      align: 'right',
      format: 'currency'
    },
  ];

  return (
    <div className="courses-list">
      <div className="list-header">
        <h2>Courses</h2>
        <button 
          className="export-btn" 
          onClick={handleExport}
          disabled={exporting}
        >
          <img src={exporticon} alt="Export" />
          {exporting ? 'Exporting...' : 'Export'}
        </button>
      </div>

      <FinanceTable
        data={courses}
        columns={columns}
        loading={loading}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onRowClick={handleRowClick}
      />
    </div>
  );
};
